// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_SUBMIT_MESSAGE = "Odo\u0161li spr\u00e1vu";
export const VISIBILITY_CHECKBOX_LABEL = "Zverejni aj pre neregistrovan\u00fdch";
